/**
 * This function is used to parse a JSONB string into an object of type T.
 * If the input is not a valid JSON string, it returns null.
 * @template T - The type of the object to parse.
 * @param json
 * @returns
 */
export function parseJsonb<T>(json: any): T | null {
	try {
		if (!json) throw new Error("Input is null or undefined");
		if (typeof json === "object") {
			return json as T;
		}
		if (typeof json !== "string") throw new Error("Input is not a string");
		return JSON.parse(json) as T;
	} catch {
		return {} as T;
	}
}
